import { createContext, useContext } from 'react'
import { TASKS_CONTEXT_ACTION_TYPES } from './tasks-context-reducer'

export const TasksContext = createContext(null)
export const TasksContextDispatch = createContext(null)

export const useTasksContext = () => {
  return useContext(TasksContext)
}

export const useTasksContextDispatch = () => {
  return useContext(TasksContextDispatch)
}

// Dispatch helpers

export const setSelectedTask = ({ taskId } = {}) => {
  return {
    type: TASKS_CONTEXT_ACTION_TYPES.SET_SELECTED_TASK,
    taskId,
  }
}
